import * as React from 'react'
import type {SVGProps} from 'react'
const MinicartClose = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={20} height={19} viewBox="0 0 19 21" {...props}>
        <g fill="none" fillRule="evenodd">
            <g>
                <g>
                    <g>
                        <g transform="translate(-335 -691) translate(335 655) translate(0 38) rotate(-45 7.013 13.815)">
                            <rect
                                width="2.349"
                                height="22.703"
                                x="10.77"
                                y=".593"
                                fill="#666"
                                rx="1.174"
                            />
                            <rect
                                width="22.703"
                                height="2.349"
                                x="1.788"
                                y="9.136"
                                fill="#FFF"
                                rx="1.174"
                            />
                            <rect
                                width="22.703"
                                height="2.349"
                                x=".681"
                                y="12.458"
                                fill="#FFF"
                                rx="1.174"
                            />
                            <rect
                                width="22.703"
                                height="2.349"
                                x=".783"
                                y="10.96"
                                fill="#666"
                                rx="1.174"
                            />
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
)
export default MinicartClose
